import { AuthContext } from 'Providers/AuthProvider'
import { useContext } from 'react'
import { AdminLoginRequestModel } from 'types/admin'
import { setWithExpiry } from 'utils/localStorage'
import useLogout from './useLogout'

const useAuthContext = () => {
  const { onLogout } = useLogout()
  const { onLogin, onSetProfile, ...rest } = useContext(AuthContext)
  const handleLogin = async (payload: AdminLoginRequestModel) => {
    const res = await onLogin(payload)
    if (res?.ErrorCode === 0) {
      const expiredTime = 24 * 60 * 60 * 60 // 24 hours
      setWithExpiry('userName', payload.userName, expiredTime)
      setWithExpiry('password', payload.password, expiredTime)
      onSetProfile(res.Result)
    }
    return res
  }

  const handleLogout = async () => {
    sessionStorage.removeItem('userName')
    sessionStorage.removeItem('password')
    onSetProfile(undefined)
    return await onLogout(rest?.profile?.UserName || '')
  }
  return { handleLogin, handleLogout, ...rest }
}

export default useAuthContext
